import RecoveryPage from "./Recovery";

export default RecoveryPage